import React from 'react';
import imgurl from '../assests/images/imgurl';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";

function NewHeader() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const addr = ['/profilepage', '/taketest', '/prescupld', '/presclist', '']

  return (
    <div className="newheader">
      <div class="logo">
        <img src={imgurl.logo1} alt="Alopexia Logo" />
      </div>
      <div class="hamburger-menu" onClick={() => setOpen(true)}>
        <img src={imgurl.stack} alt="Stack Logo" />
      </div>
      <Drawer
        anchor={'right'}
        open={open}
        onClose={() => setOpen(false)}
        className='sidebar'
      >
        {/* <List>
          {['Profile', 'Take a Test', 'Upload Prescription', 'Prescription Summary', 'Order Tracking'].map((text, index) => (
            <div>
              <ListItem key={text} disablePadding>
                <ListItemButton onClick={() => { navigate(addr[index]) }} className='sidebarlibtn'>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
              <Divider />
            </div>
          ))}
        </List> */}
        {/* <div className='ellipseclose'>
          <div className='ellipse'>
            <p>X</p>
          </div>
        </div> */}
        <Grid xs={12} className='sidebarsectionone'>
          <Grid xs={4} className='clientdetails'>
            <img src={imgurl.sidebarprofile} alt="Sidebar profile " />
            <div className='clientinfo'>
              <p className='name'>Client name</p>
              <p className='number'>{'+'+localStorage.getItem('phno')}</p>
            </div>
          </Grid>
          {/* <Grid xs={4} className='clientrating'>
            <div className='star'>
              <img src={imgurl.star} alt="Star icon" />
              <p>4.9</p>
            </div>

            <div className='feedback'>
              <img src={imgurl.feedback} alt="Feedback icon " />
              <p>Feedback</p>
            </div>
          </Grid> */}

          <Grid xs={4} className='editprofile'>
            <button className='editprofilebtn'>
              <p>Edit Profile</p>
            </button>
          </Grid>
        </Grid>
        <hr class="divider sidebardivider" />

        <Grid xs={12} className='sidebarsectiontwo'>
          <Grid xs={6} className='menu'>
            <p className='sidebarheader'>Menu</p>

            <div className='sidebarmenuitems'>
              <img src={imgurl.test} alt="Take Test " />
              <p className='menuitemtext' onClick={() => { navigate('/taketest') }}>Take Test</p>
            </div>

            <div className='sidebarmenuitems'>
              <img src={imgurl.uploadpres} alt="Upload Prescription " />
              <p className='menuitemtext'onClick={() => { navigate('/prescupld') }}>Upload Prescription</p>
            </div>

            <div className='sidebarmenuitems'>
              <img src={imgurl.summary} alt="Prescription Summary " />
              <p className='menuitemtext' onClick={() => { navigate('/presclist') }}>Prescription Summary</p>
            </div>

            <div className='sidebarmenuitems'>
              <img src={imgurl.cart} alt="Order Tracing" />
              <p className='menuitemtext' onClick={() => { navigate('/') }}>Order Tracing</p>
            </div>

          </Grid>

          <Grid xs={6} className='settings'>
            <Grid xs={4}>
              <p className='sidebarheader'>Settings</p>

              <div className='sidebarmenuitems'>
                <img src={imgurl.globe} alt="Language" />
                <p className='menuitemtext'>Language</p>
              </div>

              <div className='sidebarmenuitems'>
                <img src={imgurl.notification} alt="Notification" />
                <p className='menuitemtext'>Notification</p>
              </div>
            </Grid>

            <Grid xs={2}>
              <p className='sidebarheader'>About Us</p>

              <div className='sidebarmenuitems'>
                <img src={imgurl.security} alt="Privacy Policy" />
                <p className='menuitemtext'>Privacy Policy</p>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
    </div>
  );
}

export default NewHeader;